import { Popover, Tag } from 'antd';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import React, { CSSProperties, useCallback } from 'react';
import { MdWarning } from 'react-icons/md';
import { styled } from 'styled-components';
import { computeRemSize } from '@ydistri/theme';

const MarginedTag = styled(Tag)<{ $cursor?: CSSProperties['cursor'] }>`
  margin-top: ${computeRemSize(3)};
  margin-bottom: ${computeRemSize(3)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  ${p => p.$cursor && `cursor: ${p.$cursor};`}
`;

interface ConfigurationMultiselectTagProps extends Partial<CustomTagProps> {
  error?: React.ReactNode;
  warning?: React.ReactNode;
  onClick?: () => void;
}

const ConfigurationMultiselectTag: React.FC<ConfigurationMultiselectTagProps> = ({
  closable,
  disabled,
  error,
  label,
  onClick,
  onClose,
  warning,
}) => {
  const onPreventMouseDown = useCallback(
    (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
      if (!disabled && onClick) onClick();
    },
    [disabled, onClick],
  );

  const message = error ?? warning;
  let color: 'gold' | 'red' | undefined;
  if (error) color = 'red';
  else if (warning) color = 'gold';
  const tag = (
    <MarginedTag
      color={color}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      $cursor={message && !disabled ? 'pointer' : undefined}
    >
      {label}
      {message && <MdWarning aria-label="Warning" size={16} />}
    </MarginedTag>
  );

  return message ? <Popover content={message}>{tag}</Popover> : tag;
};

export default ConfigurationMultiselectTag;
